import { useCallback } from 'react';
import { useWebSocketClient } from 'renderer/utils';
var CID_WEBSOCKET_EVENT;
(function (CID_WEBSOCKET_EVENT) {
    CID_WEBSOCKET_EVENT[CID_WEBSOCKET_EVENT["CONNECTED"] = 100] = "CONNECTED";
    CID_WEBSOCKET_EVENT[CID_WEBSOCKET_EVENT["DISCONNECTED"] = 109] = "DISCONNECTED";
    CID_WEBSOCKET_EVENT[CID_WEBSOCKET_EVENT["CALL_START"] = 110] = "CALL_START";
    CID_WEBSOCKET_EVENT[CID_WEBSOCKET_EVENT["CALL_RINGING"] = 111] = "CALL_RINGING";
    CID_WEBSOCKET_EVENT[CID_WEBSOCKET_EVENT["CALL_ANSWER"] = 112] = "CALL_ANSWER";
    CID_WEBSOCKET_EVENT[CID_WEBSOCKET_EVENT["CALL_DISCONNECT"] = 119] = "CALL_DISCONNECT";
    CID_WEBSOCKET_EVENT[CID_WEBSOCKET_EVENT["ERROR_NOT_CONNECT"] = 901] = "ERROR_NOT_CONNECT";
    CID_WEBSOCKET_EVENT[CID_WEBSOCKET_EVENT["ERROR_DIAL_FAILED"] = 920] = "ERROR_DIAL_FAILED";
    CID_WEBSOCKET_EVENT[CID_WEBSOCKET_EVENT["ERROR_ETC"] = 999] = "ERROR_ETC";
})(CID_WEBSOCKET_EVENT || (CID_WEBSOCKET_EVENT = {}));
var CID_WEBSOCKET_COMMAND;
(function (CID_WEBSOCKET_COMMAND) {
    CID_WEBSOCKET_COMMAND[CID_WEBSOCKET_COMMAND["CALL_DIAL"] = 201] = "CALL_DIAL";
    CID_WEBSOCKET_COMMAND[CID_WEBSOCKET_COMMAND["CALL_HANGUP"] = 301] = "CALL_HANGUP";
})(CID_WEBSOCKET_COMMAND || (CID_WEBSOCKET_COMMAND = {}));
var CID_WEBSOCKET_URL = 'ws://localhost:8181';
export var useCidWebSocketClient = function (handleMessage) {
    var onMessage = useCallback(function (ev) {
        if (handleMessage) {
            try {
                handleMessage(JSON.parse(ev.data));
            }
            catch (err) { }
        }
    }, [handleMessage]);
    var _a = useWebSocketClient(CID_WEBSOCKET_URL, onMessage), client = _a.client, status = _a.status, connect = _a.connect, disconnect = _a.disconnect, sendMessage = _a.sendMessage;
    var callPhone = useCallback(function (phoneNumber) {
        sendMessage({
            evt_id: CID_WEBSOCKET_COMMAND.CALL_DIAL,
            evt_data: phoneNumber
        });
    }, [sendMessage]);
    var hangup = useCallback(function () {
        sendMessage({
            evt_id: CID_WEBSOCKET_COMMAND.CALL_HANGUP,
            evt_data: ''
        });
    }, [sendMessage]);
    return { client: client, status: status, connect: connect, disconnect: disconnect, callPhone: callPhone, hangup: hangup };
};
